import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Schemas from "../../utilities/validations";
import { useReduxStore } from "../../hooks/useReduxStore";
import { LoginAction, RegisterAction, SendOtpAction, VerifyOtpAction } from "../../store/Actions/action";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../store/Reducers/authReducer";

export default function useLogin({ isModal, onClose, closeVerificationModal, signupStandalone } = {}) {
  const [formType, setFormType] = useState("login");
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [otp, setOtp] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpSuccess, setOtpSuccess] = useState("");
  const [resendLoading, setResendLoading] = useState(false);

  const navigate = useNavigate();
  const { dispatch, getState } = useReduxStore();
  const { loginSuccess, registerSuccess, otpSent, otpVerified,OTPSuccess,token,userData,settings } = getState("AUTH");
  let { route, goBack } = window?.history?.state?.usr || {};

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    setFocus
  } = useForm({
    resolver: Schemas.logIn,
  });
  const {
    register: signupRegister,
    handleSubmit: signupHandleSubmit,
    formState: { errors: signupErrors },
    reset: resetRegister,
  } = useForm({
    resolver: Schemas.register,
  });

  const onSubmit = (data = {}) => {
    dispatch(LoginAction({ ...data }));
  };

  const onSignup = (data = {}) => {
    setSignupEmail(data.email);
    dispatch(RegisterAction({ ...data }));
  };


  useEffect(() => {
    setTimeout(() => {
      // const email = document.getElementById("email")?.value;
      // const password = document.getElementById("password")?.value;
      // setValue("email", email);
      // setValue("password", password);
      
    }, 500);
  }, [setFocus]);
  // OTP verify handler
  const onOtpSubmit = (e) => {
    e.preventDefault();
    dispatch(VerifyOtpAction({ email: token?userData.email:signupEmail, otp }));
  };
const onVerifySuccess=()=>{
         closeVerificationModal&&closeVerificationModal()   
  dispatch(updateAuth({userData:{...userData,isVerified:true}}))

}
  // OTP verify hone par login form dikhao
  useEffect(() => {
    if (OTPSuccess) {
     if(token){
      onVerifySuccess()
     }
   onSkip()
    }
  }, [OTPSuccess]);

  // Resend OTP
  const onResendOtp = async () => {
      dispatch(SendOtpAction({email:token?userData?.email:signupEmail}))
  };
  const onSkip = async () => {
    setShowOtpForm(false);
    setFormType("login");
    resetRegister();
    if (signupStandalone) {
      navigate("/Login");
    }
  };

  const onNavigate = () => {
    if (!isModal) navigate("/Dashboard");
    else {
      onClose&&   onClose();
    }
  };
  const onRegisterSuccess = () => {
    // resetRegister();
    // setFormType("login");
      setShowOtpForm(true);

  };
  useEffect(() => {
    loginSuccess && onNavigate();
  }, [loginSuccess]);
  useEffect(() => {
    registerSuccess && onRegisterSuccess();
  }, [registerSuccess]);
  // OTP send hone par OTP form dikhao

  return {
    register,
    handleSubmit,
    onSubmit,
    signupHandleSubmit,
    signupRegister,
    signupErrors,
    errors,
    onSignup,
    formType,
    setFormType,
    showOtpForm,
    otp,
    setOtp,
    onOtpSubmit,
    otpError,
    otpSuccess,
    resendLoading,
    settings,
    onResendOtp,
    onSkip,
    signupEmail,
  };
}
